(function () {
	'use strict';

	angular.module('app.core')
		.directive('stockRequirementChart', stockRequirementChart);

	stockRequirementChart.$inject = [];
	function stockRequirementChart() {
		var directive = {
			restrict: 'EA',
			templateUrl: 'core/item-drilldown/stock-requirement-chart.html',
			scope: {
				chartId: '@',
				itemId: '=',
				itemCode: '=',
				siteId: '=',
				itemMasterData: '=',
				incomingLocation: '@',
				haveCurrentShortage: '@',
				mrpTabReady: '=',
				shortageRootCauseType: '@'
			},
			link: linkFunc,
			controller: stockRequirementChartCtrl,
			controllerAs: 'stockRequirementChartCtrl',
			bindToController: true
		};

		return directive;

		function linkFunc(scope, el, attr, vm) { }
	}

	stockRequirementChartCtrl.$inject = ['$rootScope', '$scope', '$timeout', '$filter', '$q', 'itemDetailsService', 'formatterService', 'integerFormatService',
		'numberFormatService', 'fullPageChart', 'stockRequirementFiltersService', '$experiments', 'storeService'];
	function stockRequirementChartCtrl($rootScope, $scope, $timeout, $filter, $q, itemDetailsService, formatterService, integerFormatService,
			numberFormatService, fullPageChart, stockRequirementFiltersService, $experiments, storeService) {
		var vm = this;
		var mrpDataLoadingTimeout;
		var chartVisibilityObserver;
		var itemMetricData = [];
		var mrpListData = undefined;
		var stockRequirementMinDate = undefined;
		var shortagesExist = false;
		var originalItemMetricFilterValues = {
			inventoryOnHand: false,
			requirementsInsideLeadTime: false,
			blockedStock: false, 
			onOrderInsideLeadTime: false,
			unrestrictedAndConsignmentStock: true,
			daysCoverage: false,
			daysUntilShortage: false,
			pastDueRequirements: false,
			totalRequirements: false,
			pastDuePOs: false,
			totalPOs: false,
			targetQuantity: true,
			minLevel: false,
			maxLevel: false,
			erpOrderPolicy: false,
			orderInterval: false,
			leadTime: false,
			reorderPoint: false,
			reorderQuantity: false,
			erpExceptionMsgPoCt: false,
			apexPoActionPoCt: false,
			itemCost: false,
			poToActionPotentialSavings: false,
			poToActionRemainingPOs: false,
			poToActionRemainingRequirements: false,
			aggregateRiskScore: false,
			safetyTime: false,
			safetyStockComputed: false,
			minimumOrderQuantity: false
		};
		var doUpdateConfig = true;
		var oldFilterBeginDate;
		var oldFilterEndDate;
		var oldItemMetrics;
		var currentFilterBeginDate;
		var currentFilterEndDate;
		var originalHistoryChartData;
		var xGridLines = [];
		var rootCauseMap = {
			'Requirements Changed': ['requirementsInsideLeadTime', 'daysUntilShortage'],
			'Late PO': ['pastDuePOs', 'daysUntilShortage'],
			'On Hand Quantity Changed': ['inventoryOnHand', 'daysUntilShortage'],
			'Inaction': ['totalPOs', 'onOrderInsideLeadTime', 'totalRequirements', 'requirementsInsideLeadTime', 'daysUntilShortage'],
			'Not Enough Information': ['totalPOs', 'onOrderInsideLeadTime', 'totalRequirements', 'requirementsInsideLeadTime', 'daysUntilShortage']
		};

		vm.loadingStockSection = true;
		vm.filtersChanged = false;
		vm.openSupplyAndDemand = 'Open POs & Rqmts';
		vm.historicalMetrics = 'Historical Metrics';
		vm.viewMode = vm.openSupplyAndDemand;
		vm.itemMetrics = stockRequirementFiltersService.getItemMetrics($rootScope.authz.isLeanDNAAdmin());
		vm.persistedDateFilter = stockRequirementFiltersService.getPersistedDateFilter();
		vm.itemMetricsDataLoaded = false;
		vm.pastDueStartDate;
		vm.metricDisplay = '';
		vm.saveSiteLevelDefaultConfig = saveSiteLevelDefaultConfig;
		vm.resetToSiteDefault = resetToSiteDefault;
		updateMetricDisplay();

		vm.dateFilterClicked = dateFilterClicked;
		vm.clearDateFilter = clearDateFilter;
		vm.applyMetricFilter = applyMetricFilter;
		vm.cancelMetricFilter = cancelMetricFilter;
		vm.itemMetricFilterOpened = itemMetricFilterOpened;
		vm.metricFilterAllSelected = metricFilterAllSelected;
		vm.metricFilterNoneSelected = metricFilterNoneSelected;
		vm.metricFilterNumberSelected = metricFilterNumberSelected;
		vm.toggleAll = toggleAll;
		vm.actionsSidebarOpen;
		var unsubscribe = storeService.subscribe(function () {
			var state = storeService.getState();
			if (vm.actionsSidebarOpen === undefined) {
				vm.actionsSidebarOpen = state.itemDrilldown.actionsSidebarOpen;
			} else if (vm.actionsSidebarOpen !== state.itemDrilldown.actionsSidebarOpen) {
				vm.actionsSidebarOpen = state.itemDrilldown.actionsSidebarOpen;
				if (mrpListData && mrpListData.length && isReadyToGenerateChart()) generateStockRequirementChart();
			}
			// update date filters if theyve changed
			if (state.previousAction.type.startsWith('itemDrilldown/setChartStartDate') || 
					state.previousAction.type.startsWith('itemDrilldown/setChartEndDate') || 
					state.previousAction.type.startsWith('itemDrilldown/setChartStartEndDates') || 
					state.previousAction.type.startsWith('itemDrilldown/resetChartTimeRange')) {
				var chartState = state.itemDrilldown.stockRequirementsChart[vm.viewMode];
				vm.filterValues = stockRequirementFiltersService.getDateFilter(vm.viewMode);
				
				var startDateChanged = chartState.startDate && vm.filterValues && !isNullableDatesEqual(new Date(chartState.startDate.value), new Date(vm.filterValues.filterBeginDate));
				var endDateChanged = chartState.endDate && vm.filterValues && !isNullableDatesEqual(new Date(chartState.endDate.value), new Date(vm.filterValues.filterEndDate));
				if (startDateChanged) {
					vm.filterValues.filterBeginDate = chartState.startDate.value;
					vm.filterValues.filterBeginId = chartState.startDate.id;
				}
				if (endDateChanged) {
					vm.filterValues.filterEndDate = chartState.endDate.value;
					vm.filterValues.filterEndId = chartState.endDate.id;
				}
				if (isReadyToGenerateChart()) {
					setChartVariables();
				}
				if (startDateChanged || endDateChanged) {
					if (vm.viewMode !== state.previousAction.payload.viewMode) {
						return;
					}
					applyFilters(state.previousAction.payload.isAutoAdjusted);
				}
			} else if (state.previousAction.type.startsWith('itemDrilldown/addSupplyFilters')) {
				var filtersState = state.itemDrilldown.filters;
				vm.supplyFilters = stockRequirementFiltersService.getSupplyFilters();
				Object.assign(vm.supplyFilters, filtersState);
				if (isReadyToGenerateChart()) {
					setChartVariables();
					vm.filtersChanged = isConfigDifferentFromSite();
				}
				applyFilters(state.previousAction.payload.isAutoAdjusted);
			} else if (state.previousAction.type.startsWith('leanTableData/update-po-comment/fulfilled')) {
				// for now only do it for date, since that the only affecting the chart.
				if(state.previousAction.payload.parameter === 'firstPoEcdDate') {
					stockRequirementFiltersService.updateRowDataAfterEdited(vm.viewMode, state.previousAction.payload);
					if (isReadyToGenerateChart()) {
						setChartVariables();
					}
				}
			}
		});

		function isConfigDifferentFromSite() {
			var localConfig = Object.values(vm.supplyFilters).map(function (f) { return { id:f.id, values: _.sortBy(f.values) };});
			var siteConfig = Object.values(stockRequirementFiltersService.getSupplyAndDemandDefaultFilters()).map(function (f) {return {  id:f.id, values: _.sortBy(f.values) };});
			return !_.isEqual(_.sortBy(localConfig, 'id'), _.sortBy(siteConfig, 'id'));
		}

		function saveSiteLevelDefaultConfig() {
			stockRequirementFiltersService.saveSiteLevelDefaultConfig();
			vm.filtersChanged = false;
		}

		function resetToSiteDefault() {
			$timeout(function() {
				stockRequirementFiltersService.resetToSiteDefault();
				vm.filterValues = stockRequirementFiltersService.getDateFilter(vm.viewMode);
				vm.supplyFilters = stockRequirementFiltersService.getSupplyFilters(true);
				setChartVariables();
				if (doUpdateConfig) {
					stockRequirementFiltersService.deleteConfig();
					vm.filtersChanged = false;
				}
			}, 0);
		}

		function isReadyToGenerateChart() {
			return vm.itemMetricsDataLoaded && !stockRequirementFiltersService.getMrpDataLoading(vm.viewMode) && vm.itemMasterData != null;
		}

		function isNullableDatesEqual(dateOne, dateTwo) {
			if (!dateOne && !dateTwo) return true;
			if (!dateOne || !dateTwo) return false;
			return dateOne.getTime() === dateTwo.getTime();
		}

		// BEGIN Stock Requirement Filters
		function dateFilterClicked() {
			currentFilterBeginDate = vm.filterValues.filterBeginDate;
			currentFilterEndDate = vm.filterValues.filterEndDate;
		}

		function clearDateFilter() {
			vm.filterValues.filterBeginDate = currentFilterBeginDate;
			vm.filterValues.filterEndDate = currentFilterEndDate;
		}

		function applyFilters(isAutoAdjusted) {
			if (!isAutoAdjusted && doUpdateConfig) {
				stockRequirementFiltersService.updateConfig('dateFilter');
			}
		}

		function itemMetricFilterOpened() {
			_.forEach(vm.itemMetrics, function (metric) {
				originalItemMetricFilterValues[metric.key] = metric.selected;
			});
		}

		function cancelMetricFilter() {
			_.forEach(vm.itemMetrics, function (metric) {
				metric.selected = originalItemMetricFilterValues[metric.key];
			});
		}

		function applyMetricFilter() {
			updateMetricDisplay();
			generateStockRequirementChart();
			if (doUpdateConfig) {
				stockRequirementFiltersService.updateConfig('itemMetrics');
			}
		}

		function updateMetricDisplay() {
			var display = '';
			var allSelected = true;
			var noneSelected = true;
			_.forEach(vm.itemMetrics, function (metric) {
				if (metric.selected) {
					noneSelected = false;
					if (display && display.length) {
						display += ', ';
					}
					display += metric.display;
				} else {
					allSelected = false;
				}
			});
			if (allSelected) {
				vm.metricDisplay = 'All';
			} else if (noneSelected) {
				vm.metricDisplay = 'None';
			} else {
				vm.metricDisplay = display;
			}
		}

		function setDefaultItemMetricDateFilter() {
			var currentTime = new Date();
			var minDate = moment('2017-12-10'); // First time item metrics was added
			if (!stockRequirementMinDate || stockRequirementMinDate.isAfter(moment())) {
				currentTime.setHours(0, 0, 0, 0);
				currentTime.setDate(currentTime.getDate() - 90);
				vm.filterValues.filterBeginDate = currentTime;
			} else if (stockRequirementMinDate && stockRequirementMinDate.isBefore(minDate)) {
				vm.filterValues.filterBeginDate = minDate.toDate();
			} else {
				vm.filterValues.filterBeginDate = stockRequirementMinDate.toDate();
			}
		}

		function metricFilterNumberSelected() {
			var i = 0;
			_.forEach(vm.itemMetrics, function (metric) {
				if (metric.selected) {
					i++;
				}
			});
			return i;
		}

		function metricFilterAllSelected() {
			for (var i = 0; i < vm.itemMetrics.length; i++) {
				if (!vm.itemMetrics[i].selected) {
					return false;
				}
			}
			return true;
		}

		function metricFilterNoneSelected() {
			for (var i = 0; i < vm.itemMetrics.length; i++) {
				if (vm.itemMetrics[i].selected) {
					return false;
				}
			}
			return true;
		}

		function toggleAll() {
			var newValue = false;
			if (metricFilterNoneSelected()) {
				newValue = true;
			}
			_.forEach(vm.itemMetrics, function(itemMetric) {
				itemMetric.selected = newValue;
			});
		}
		// END Stock requirement filters

		function getItemMetrics(loadNewData) {
			var list = stockRequirementFiltersService.getItemMetricData(vm.viewMode);
			if (list && list.length && !loadNewData) {
				itemMetricData = list;
				vm.itemMetricsDataLoaded = true;
			} else if (vm.itemId) {
				var requestTimestamp = moment().toDate().getTime();
				$scope.requestTime = requestTimestamp;
				return itemDetailsService.getItemMetrics(vm.itemId, vm.siteId, '', '')
					.then(function (data) {
						if ($scope.requestTime !== requestTimestamp) {
							return;
						}
						var pastDuePosStartDate;
						var pastDueRequirementsStartDate;
						if (data.pastDuePOs && data.pastDuePOs.length) {
							var pastDuePos = data.pastDuePOs.filter(function (row) { return row.newValue != 0; });
							if (pastDuePos.length) pastDuePosStartDate = _.orderBy(pastDuePos, 'startDate', 'asc')[0].startDate;
						}
						if (data.pastDueRequirements && data.pastDueRequirements.length) {
							var pastDueRequirements = data.pastDueRequirements.filter(function (row) { return row.newValue != 0; });
							if (pastDueRequirements.length) pastDueRequirementsStartDate = _.orderBy(pastDueRequirements, 'startDate', 'asc')[0].startDate;
						}
						if (pastDuePosStartDate || pastDueRequirementsStartDate) {
							if (!pastDuePosStartDate) vm.pastDueStartDate = pastDueRequirementsStartDate;
							else if (!pastDueRequirementsStartDate) vm.pastDueStartDate = pastDuePosStartDate;
							else vm.pastDueStartDate = Math.min(pastDuePosStartDate, pastDueRequirementsStartDate);
						}
				 		vm.itemMetricsDataLoaded = true;
						itemMetricData = processItemMetricData(data);
						stockRequirementFiltersService.setItemMetricData(vm.viewMode, itemMetricData);
						generateStockRequirementChart();
					});
			}
		}

		function getMrpList() {
			vm.loadingStockSection = true;
			var list = stockRequirementFiltersService.getMrpData(vm.viewMode);
			if (list && list.length) {
				handleMrpData();
			} else {
				var target = vm.itemMasterData.analysisTargetInventoryQty;
				var unrestrictedWithConsignment = vm.itemMasterData.totalOnHandUnrestrictedQuantity +
					vm.itemMasterData.totalOnHandUnrestrictedConsignmentQuantity;

				if (unrestrictedWithConsignment % 1 !== 0) {
					vm.itemMasterData.currentStock = numberFormatService.getWithParameters(
						unrestrictedWithConsignment, decimalPlaces(unrestrictedWithConsignment));
				} else {
					vm.itemMasterData.currentStock = integerFormatService.getWithParameters(unrestrictedWithConsignment, 0);
				}
				if (stockRequirementFiltersService.getMrpDataLoading(vm.viewMode)) {
					mrpDataLoadingTimeout = $timeout(function () {
						getMrpList();
					}, 15);
				} else {
					return stockRequirementFiltersService.loadMrpList(vm.itemMasterData.code, vm.siteId, target,
						unrestrictedWithConsignment, vm.itemMasterData.leadTimeInDaysFloat, vm.viewMode)
						.then(function (data) {
							handleMrpData();
						});
				}
			}
		}

		function handleMrpData() {
			vm.todayDate = $filter('date')(new Date(), 'shortDate');
			setChartVariables();
			vm.loadingStockSection = false;
		}

		function setChartVariables() {
			processMrpListData();
			generateStockRequirementChart();
		}

		function getRootCauseDate(useRootCauseDate) {
			xGridLines = [];
			vm.historicalValue = vm.historicalMetrics;
			
			return itemDetailsService.getShortageData(vm.itemId, vm.siteId).then(function(data) {
				var filterDate = new Date();
				if (data && data.rootCauseDate) {
					xGridLines.push({
						value: data.rootCauseDate,
						text: 'Root Cause Date'
					});
					filterDate.setTime(data.rootCauseDate);
					filterDate.setHours(0, 0, 0, 0);
					filterDate.setDate(filterDate.getDate() - 7);
				} else {
					filterDate.setHours(0, 0, 0, 0);
					filterDate.setDate(filterDate.getDate() - vm.itemMasterData.leadTimeInDaysFloat - 7);
				}
				if (useRootCauseDate) {
					oldFilterBeginDate = vm.filterValues.filterBeginDate;
					oldFilterEndDate = vm.filterValues.filterEndDate;
					oldItemMetrics = [];
					var itemMetricsToBeSelected;
					if (vm.shortageRootCauseType) {
						itemMetricsToBeSelected = rootCauseMap[vm.shortageRootCauseType];
					}
					vm.itemMetrics.forEach(function (metric) {
						if (metric.selected) {
							oldItemMetrics.push(metric.key);
						}
						if (itemMetricsToBeSelected && itemMetricsToBeSelected.length) {
							if (itemMetricsToBeSelected.indexOf(metric.key) >= 0) {
								metric.selected = true;
							} else {
								metric.selected = false;
							}
							updateMetricDisplay();
						}
					});
					vm.filterValues.filterBeginDate = filterDate;
					filterDate = new Date();
					filterDate.setDate(filterDate.getDate() + 1);
					filterDate.setHours(0, 0, 0, 0);
					vm.filterValues.filterEndDate = filterDate;
				}
			});
		}

		function getEndOfWeek(d) {
			// isoWeek ends on sunday
			return moment(d).tz('UTC').endOf('isoWeek').subtract(1, 'day');
		}

		function processItemMetricData(data) {
			var currentTime = new Date();
			currentTime.setUTCHours(0, 0, 0, 0);
			var endTime = new Date(vm.filterValues.endDate);

			if (!endTime || endTime.getTime() > currentTime.getTime()) {
				endTime = currentTime;
			}
			var resultList = [];
			if (!data || _.isEmpty(data)) {
				return resultList;
			}
			var i = data.daysUntilShortage.length;

			// Plot a point every single day for daysUntilShortage
			while (i--) {
				var row = data.daysUntilShortage[i];
				if (row.newValue && row.isFake !== true) {
					var daysStart = new Date(row.startDate);
					daysStart.setDate(daysStart.getDate() + 1);
					var daysEnd;

					if (row.endDate) {
						daysEnd = new Date(row.endDate);
					} else {
						// This is the most recent point, extend out till needed
						daysEnd = endTime;
					}

					var fakeValueArray = [];

					// Calculate diff from daysUntilShortage data
					var startDate = moment(row.startDate).startOf('day');
					var shortageDate = moment(row.newValue * 1000).startOf('day');
					var daysUntilShortage = shortageDate.diff(startDate, 'days');

					// Do not display negative values for this metric
					if (daysUntilShortage <= 0) {
						daysUntilShortage = 0;
					}

					// Change current value to daysUntilShortage instead of broken epoch time
					row.newValue = daysUntilShortage;

					for (var d = daysStart; d < daysEnd; d.setDate(d.getDate() + 1)) {
						// Do not extend this beyond the range we want to display
						if (endTime && endTime.getTime() < daysEnd.getTime()) {
							break;
						}
						if (daysUntilShortage > 0) {
							daysUntilShortage--;
						}
						fakeValueArray.push({
							newValue: daysUntilShortage,
							startDate: d.getTime(),
							isFake: true,
							diff: -1
						});
					}
					data.daysUntilShortage.splice(i + 1, 0, fakeValueArray);
				} else {
					// There is no shortage
					row.newValue = null;
					row.noShortage = true;
				}
			}

			data.daysUntilShortage = _.flattenDeep(data.daysUntilShortage, 2);

			// Check for date ranges larger than ~1 day
			// Fill with values from previous point in order to show immediate change
			_.forEach(data, function (rowOuter, metricName) {
				if (metricName !== 'daysUntilShortage') {
					_.forEach(rowOuter, function (rowInner, index) {
						if (rowInner.endDate) {
							if (endTime && endTime.getTime() < rowInner.endDate) {
								return; // continue in lodash
							}
							var endDate = new Date(rowInner.endDate);
							var hourDiff = Math.abs(new Date(rowInner.startDate) - endDate) / 3600000;
							if (hourDiff > 30) {
								var newPointDate = new Date(rowInner.endDate);
								newPointDate.setDate(endDate.getDate() - 1);
								var fakePoint = {
									newValue: rowInner.newValue,
									startDate: newPointDate.getTime(),
									isFake: true
								};
								if (metricName === 'erpOrderPolicy') {
									fakePoint.newValueString = rowInner.newValueString;
									fakePoint.oldValueString = rowInner.oldValueString;
								}
								rowOuter.splice(index + 1, 0, fakePoint);
							}
						}
					});
				}
			});

			// Collapse all points into one array
			var dates = [];
			var organizedData = {};
			_.forEach(data, function (rowOuter, metricName) {
				_.forEach(rowOuter, function (rowInner, index) {
					if (!organizedData[rowInner.startDate]) {
						organizedData[rowInner.startDate] = {};
						dates.push(rowInner.startDate);
					}
					var pointValue = rowInner.newValue;
					if (metricName === 'erpOrderPolicy') {
						if (rowInner.newValueString != null && rowInner.newValueString !== '') {
							organizedData[rowInner.startDate][metricName + 'Label'] = rowInner.newValueString;
						}
						pointValue = null;
					}
					organizedData[rowInner.startDate][metricName] = pointValue;
					if (!organizedData[rowInner.startDate].isFake) {
						organizedData[rowInner.startDate].isFake = (rowInner.isFake === true);
					}
					if (rowInner.noShortage) {
						organizedData[rowInner.startDate].noShortage = true;
					}
					if (metricName === 'erpOrderPolicy') {
						var oldPol = rowInner.oldValueString;
						var newPol = rowInner.newValueString;
						if (oldPol !== undefined || newPol !== undefined) {
							organizedData[rowInner.startDate][metricName + 'Diff'] =
								(oldPol || '') + ' \u2192 ' + (newPol || '');
						} else {
							organizedData[rowInner.startDate][metricName + 'Diff'] = '--';
						}
					} else if (rowInner.diff !== undefined || (!rowInner.isFake && rowInner.oldValue && rowInner.newValue)) {
						var diff;
						if (metricName === 'daysUntilShortage') {
							diff = rowInner.newValue;
							if (index !== 0) {
								diff -= rowOuter[index - 1].newValue;
							}
						} else {
							diff = rowInner.newValue - rowInner.oldValue;
						}
						var decimals = numberOfDecimals(diff, 2);
						diff = numberFormatService.getWithParameters(diff, decimals, true);
						organizedData[rowInner.startDate][metricName + 'Diff'] = parseFloat(diff);
					} else {
						organizedData[rowInner.startDate][metricName + 'Diff'] = '--';
					}
				});
			});
			dates.sort();

			var collapsedData = [];
			_.forEach(dates, function (date) {
				var point = organizedData[date];
				point.startDate = date;
				collapsedData.push(point);
			});
			data = collapsedData;

			// Fill missing values in
			_.forEach(data, function (row, index) {
				var previousRow = data[index - 1];
				for (var i = 0; i < vm.itemMetrics.length; i++) {
					var metricName = vm.itemMetrics[i].key;
					// Don't extend if there isn't a shortage
					if (metricName === 'daysUntilShortage' && row.noShortage) {
						row[metricName] = '--';
						row[metricName + 'Diff'] = '--';
					} else if (metricName === 'inventoryOnHand') {
						continue;
					} else if (metricName === 'erpOrderPolicy') {
						if (!row[metricName + 'Label'] && index !== 0 && previousRow) {
							row[metricName + 'Label'] = previousRow[metricName + 'Label'];
							row[metricName + 'Diff'] = '--';
						}
					} else if (metricName !== 'erpOrderPolicy' && !row[metricName] && row[metricName] !== 0) {
						row[metricName] = index !== 0 ? previousRow[metricName] : '--';
						row[metricName + 'Diff'] = '--';
					}
				}

				// Format daysCoverage
				if (row.daysCoverage && row.daysCoverage !== '--') {
					var decimals = numberOfDecimals(row.daysCoverage, 2);
					row.daysCoverage = numberFormatService.getWithParameters(row.daysCoverage, decimals, true);
					row.daysCoverage = parseFloat(row.daysCoverage);
				}
			});

			// Check to see if we need to fill the tail end of chart
			// This should only happen if there is no shortage at the tail
			if ((endTime && data[data.length - 1].startDate < endTime.getTime()) ||
				(!endTime && data[data.length - 1].startDate < currentTime.getTime())) {
				var endRow = data[data.length - 1];
				var lastPoint = _.clone(endRow);
				for (var i = 0; i < vm.itemMetrics.length; i++) {
					var metricName = vm.itemMetrics[i].key;
					lastPoint[metricName + 'Diff'] = '--';
				}
				lastPoint.startDate = endTime.getTime();
				lastPoint.isFake = true;
				data.push(lastPoint);
			}

			// Save original data so table can filter itself and return to original state
			originalHistoryChartData = data;

			// Add empty point at selected begin date if needed
			if (vm.filterValues.filterBeginDate && originalHistoryChartData[0].startDate > new Date(vm.filterValues.filterBeginDate).getTime()) {
				originalHistoryChartData.unshift({
					startDate: new Date(vm.filterValues.filterBeginDate).getTime()
				});
			}
			
			// Fill missing days in the data to ensure daily continuity
			originalHistoryChartData = fillMissingDaysInHistoryData(originalHistoryChartData);
			
			addInventoryOnHandAndSetEndDate(originalHistoryChartData);
			return originalHistoryChartData;
		}

		function fillMissingDaysInHistoryData(data) {
			if (!data || data.length < 2) {
				return data;
			}

			var filledData = [];
			var millisecondsPerDay = 24 * 60 * 60 * 1000;

			for (var i = 0; i < data.length; i++) {
				var currentElement = data[i];
				filledData.push(currentElement);

				// Check if there's a next element to compare with
				if (i < data.length - 1) {
					var nextElement = data[i + 1];
					var currentDate = new Date(currentElement.startDate);
					var nextDate = new Date(nextElement.startDate);
					
					// Calculate the difference in days
					var daysDiff = Math.floor((nextDate.getTime() - currentDate.getTime()) / millisecondsPerDay);
					
					// If gap is more than 1 day, fill the missing days
					if (daysDiff > 1) {
						for (var dayOffset = 1; dayOffset < daysDiff; dayOffset++) {
							var missingDate = new Date(currentDate.getTime() + (dayOffset * millisecondsPerDay));
							
							// Create new element by copying current element's data
							var missingDayElement = _.cloneDeep(currentElement);
							
							// Update the date to the missing day
							missingDayElement.startDate = missingDate.getTime();
							missingDayElement.endDate = missingDate.getTime();
							
							// Mark as fake data
							missingDayElement.isFake = true;
							
							// Reset all diff properties to '--' since this is interpolated data
							for (var j = 0; j < vm.itemMetrics.length; j++) {
								var metricName = vm.itemMetrics[j].key;
								if (missingDayElement[metricName + 'Diff'] !== undefined) {
									missingDayElement[metricName + 'Diff'] = '--';
								}
							}
							
							filledData.push(missingDayElement);
						}
					}
				}
			}

			return filledData;
		}

		function addInventoryOnHandAndSetEndDate(data) {
			_.forEach(data, function (row, index) {
				var previousRow = data[index - 1];
				var blockedStockTemp = row['blockedStock'];
				var unrestrictedAndConsignmentStockTemp = row['unrestrictedAndConsignmentStock'];
				row.inventoryOnHand = blockedStockTemp + unrestrictedAndConsignmentStockTemp;
				if (index === 0) {
					row.inventoryOnHandDiff = '--';
				} else {
					var tempDiff = row.inventoryOnHand - previousRow.inventoryOnHand;
					row.inventoryOnHandDiff = tempDiff === 0 ? '--' : tempDiff;
				}
				row.endDate = row.startDate;
			});
		}

		// Chart function
		function processMrpListData() {			
			var listData = _.cloneDeep(stockRequirementFiltersService.getMrpData(vm.viewMode));
			var hasBlockedFilter = vm.supplyFilters.mrpTypes.values.indexOf('Blocked') !== -1;
			var availableQty = hasBlockedFilter ? 
				vm.itemMasterData.totalOnHandQuantityFloat + vm.itemMasterData.totalOnHandConsignmentQuantity 
				: vm.itemMasterData.totalOnHandUnrestrictedQuantity +	vm.itemMasterData.totalOnHandUnrestrictedConsignmentQuantity;
			listData = stockRequirementFiltersService.getFilteredMrpList(listData,
				availableQty, vm.itemMasterData.leadTimeInDaysFloat);
			// rearrange mrp data
			var tempChartData = {};
			var weekKey, weekData;
			// start chart no later than the current week
			stockRequirementMinDate = getEndOfWeek(moment());
			// end chart at the end of the requirement type period
			var sixMonthsFromNow = moment().tz('UTC').add(6, 'months');
			var aYearFromNow = moment().tz('UTC').add(1, 'y');
			var endDateMax = moment().tz('UTC').add(2, 'y');
			var hasLessData = listData.length < stockRequirementFiltersService.getMrpMaxResults();
			var offset = hasLessData ? 1 : 2;
			var endDate = sixMonthsFromNow;
			if (listData && listData.length > 0) {
				if (!hasLessData) {
					endDate = moment(listData[listData.length - offset].originalDate).tz('UTC');
				} else {
					endDate = moment(listData[listData.length - offset].originalDate).tz('UTC');
					if (endDate.isBefore(sixMonthsFromNow)) {
						endDate = sixMonthsFromNow;
					} else if (endDate.isBefore(aYearFromNow)) {
						endDate = aYearFromNow;
					} else if (endDate.isAfter(endDateMax)){
						endDate = endDateMax;
					}
				}
			}
			
			for (var i = listData.length - offset; i >= 0; i--) {
				var rawData = listData[i];
				var d = moment(rawData.originalDate).tz('UTC');
				
				if (d.isBefore(stockRequirementMinDate)) {
					stockRequirementMinDate = d;
				}
				weekKey = getEndOfWeek(d).format('DDDD YYYY');
				weekData = tempChartData[weekKey];
				if (weekData === undefined) {
					weekData = {
						endDate: getEndOfWeek(d).toDate(),
						lastDate: rawData.originalDate,
						totalSupplyCount: 0,
						forecasts: 0,
						requirements: 0,
						inventoryExpiration: 0,
						productionOrdersDemands: 0,
						plannedProductionOrderDemands: 0,
						transferOrders: 0, 
						plannedTransferOrders: 0, 
						customerOrders: 0, 
						purchaseOrders: 0,
						purchaseRequisitions: 0, 
						productionOrders: 0,
						plannedProductionOrders: 0,
						nonValueSupplys: 0,
						availableQuantity: rawData.availableQtyBalanceUnformatted,
						targetQty: vm.itemMasterData.analysisTargetInventoryQtyUnformatted,
						safetyStock: vm.itemMasterData.safetyStockTotal,
						pastDuePurchaseOrders: 0,
						aggregateRiskScore: 0
					};
					tempChartData[weekKey] = weekData;
				}
				// use last balance for the week
				if (rawData.originalDate > weekData.lastDate) {
					weekData.lastDate = rawData.originalDate;
					weekData.availableQuantity = rawData.availableQtyBalance;
				}

				if (rawData.MRPType === 'Forecast') {
					weekData.forecasts += -1 * rawData.originalReceiptRequirement;
				} else if (rawData.MRPType === 'Requirement') {
					weekData.requirements += -1 * rawData.originalReceiptRequirement;
				} else if (rawData.MRPType === 'InventoryExpiration') {
					weekData.inventoryExpiration += -1 * rawData.originalReceiptRequirement;
				} else if (rawData.MRPType === 'ProductionOrder') {
					weekData.productionOrdersDemands += -1 * rawData.originalReceiptRequirement;
				} else if (rawData.MRPType === 'PlannedProductionOrder') {
					weekData.plannedProductionOrderDemands += -1 * rawData.originalReceiptRequirement;
				} else if (rawData.MRPType === 'TransferOrder') {
					weekData.transferOrders += -1 * rawData.originalReceiptRequirement;
				} else if (rawData.MRPType === 'PlannedTransferOrder') {
					weekData.plannedTransferOrders += -1 * rawData.originalReceiptRequirement;
				} else if (rawData.MRPType === 'CustomerOrder') {
					weekData.customerOrders += -1 * rawData.originalReceiptRequirement;
				} else if (rawData.MRPType === 'Purchase Order') {
					weekData.purchaseOrders += rawData.originalReceiptRequirement;
					weekData.totalSupplyCount += rawData.originalReceiptRequirement;
				} else if (rawData.MRPType === 'Purchase Requisition') {
					weekData.purchaseRequisitions += rawData.originalReceiptRequirement;
					weekData.totalSupplyCount += rawData.originalReceiptRequirement;
				} else if (rawData.MRPType === 'Production Order') {
					weekData.productionOrders += rawData.originalReceiptRequirement;
					weekData.totalSupplyCount += rawData.originalReceiptRequirement;
				} else if (rawData.MRPType === 'Planned Production Order') {
					weekData.plannedProductionOrders += rawData.originalReceiptRequirement;
					weekData.totalSupplyCount += rawData.originalReceiptRequirement;
				} else if (rawData.MRPType === 'Non Value Supply') {
					weekData.nonValueSupplys += rawData.originalReceiptRequirement;
					weekData.totalSupplyCount += rawData.originalReceiptRequirement;
				}
			}

			// generate list of keys for all weeks in range
			var weekKeys = [];
			var weekDates = {};
			if (stockRequirementMinDate !== undefined) {
				var currentWeekEnd = getEndOfWeek(moment());
				// start chart no later than the current date
				if (currentWeekEnd.isBefore(getEndOfWeek(stockRequirementMinDate))) {
					stockRequirementMinDate = currentWeekEnd;
				}
				var curDate = moment(stockRequirementMinDate).tz('UTC');
				while (!curDate.isAfter(getEndOfWeek(endDate))) {
					weekKey = getEndOfWeek(curDate).format('DDDD YYYY');
					// somehow, duplicates get generated, so check if value is already in list
					if (weekKeys.indexOf(weekKey) === -1) {
						weekKeys.push(weekKey);
						weekDates[weekKey] = getEndOfWeek(curDate).toDate();
					}
					curDate.add(7, 'days');
				}
			} else {
				stockRequirementMinDate = moment().tz('UTC');
			}

			// convert tempChartData object to a list
			mrpListData = [];
			var previousAvailable = vm.itemMasterData.totalOnHandUnrestrictedQuantity + vm.itemMasterData.totalOnHandUnrestrictedConsignmentQuantity;
			var lastPointWasShortage = false;
			shortagesExist = false;
			for (i = 0; i < weekKeys.length; i++) {
				weekKey = weekKeys[i];
				weekData = tempChartData[weekKey];

				// fill in gaps with available and target quanties
				if (weekData === undefined) {
					weekData = {
						endDate: weekDates[weekKey],
						totalSupplyCount: 0,
						forecasts: 0,
						requirements: 0,
						inventoryExpiration: 0,
						productionOrdersDemands: 0,
						plannedProductionOrderDemands: 0,
						transferOrders: 0, 
						plannedTransferOrders: 0, 
						customerOrders: 0, 
						purchaseOrders: 0,
						purchaseRequisitions: 0, 
						productionOrders: 0,
						plannedProductionOrders: 0,
						nonValueSupplys: 0,
						pastDuePurchaseOrders: 0,
						availableQuantity: previousAvailable,
						targetQty: vm.itemMasterData.analysisTargetInventoryQtyUnformatted,
						safetyStock: vm.itemMasterData.safetyStockTotal,
						aggregateRiskScore: 0
					};
				} else {
					previousAvailable = weekData.availableQuantity;
				}

				// shortage
				if (weekData.availableQuantity < 0) {
					shortagesExist = true;
					weekData.shortageQuantity = weekData.availableQuantity;
					if (!lastPointWasShortage) {
						// add dummy point to this week for Available
						weekData.availableQuantity = 0;
						if (i > 0) {
							// add dummy point to last week for Shortage
							mrpListData[i - 1].shortageQuantity = 0;
						}
					} else {
						// not a new shortage, hide Available
						weekData.availableQuantity = undefined;
					}
					lastPointWasShortage = true;
				} else {
					if (lastPointWasShortage) {
						// add dummy point to this week for Shortage
						weekData.shortageQuantity = 0;
						if (i > 0) {
							// add dummy point to last week for Available
							mrpListData[i - 1].availableQuantity = 0;
						}
					}
					lastPointWasShortage = false;
				}

				mrpListData.push(weekData);
			}
		}

		function combineItemMetricsWithMrpData(metrics, mrpData) {
			var itemMetricsAndMrpData = [].concat(metrics);
			var futureDataStartIndex = -1;
			var today = new Date();
			today.setHours(0, 0, 0, 0);
			for (var i = 0; i < mrpData.length; i++) {
				if (mrpData[i].endDate) {
					var endTemp = mrpData[i].endDate;
					endTemp.setHours(0, 0, 0, 0);
					if (endTemp.getTime() >= today.getTime()) {
						futureDataStartIndex = i;
						break;
					}
				}
			}
			if (futureDataStartIndex > -1) {
				itemMetricsAndMrpData = itemMetricsAndMrpData.concat(mrpData.slice(futureDataStartIndex));
			}
			return itemMetricsAndMrpData;
		}

		function applyDateFiltersToMrpData(dataToFilter) {
			var filteredData = [].concat(dataToFilter);
			if (vm.filterValues.filterBeginDate && filteredData.length > 0) {
				var startIndex = -1;
				for (var i = 0; i < filteredData.length; i++) {
					var endTime;
					var endTemp = filteredData[i].endDate;
					if (typeof endTemp === 'number') {
						endTime = endTemp;
					} else {
						endTemp.setHours(0, 0, 0, 0);
						endTime = endTemp.getTime();
					}
					if (endTime >= new Date(vm.filterValues.filterBeginDate).getTime()) {
						startIndex = i;
						break;
					}
				}
				if (startIndex > -1) {
					filteredData = filteredData.slice(startIndex);
				}
			}
			if (vm.filterValues.filterEndDate && filteredData.length > 0) {
				var endIndex = filteredData.length - 1;
				var foundEnd = false;
				while (endIndex >= 0 && !foundEnd) {
					var endTime;
					var endTemp = new Date(filteredData[endIndex].endDate);
					if (typeof endTemp === 'number') {
						endTime = endTemp;
					} else {
						endTemp.setHours(0, 0, 0, 0);
						endTime = endTemp.getTime();
					}
					if (endTime < new Date(vm.filterValues.filterEndDate).getTime() + 24 * 60 * 60 * 1000) {
						foundEnd = true;
						break;
					}
					endIndex--;
				}
				if (endIndex > -1) {
					filteredData.length = endIndex + 1;
				} else {
					filteredData.length = 0;
				}
			}

			if (filteredData.length === 0) {
				return [{ endDate: new Date() }];
			}

			return filteredData;
		}

		function findMinOfData(data) {
			return d3.min(data, function (d) {
				var min = 0;

				if (d.availableQuantity && d.availableQuantity < min) {
					min = d.availableQuantity;
				}
				if (d.purchaseOrders && d.purchaseOrders < min) {
					min = d.purchaseOrders;
				}
				if (d.productionOrders && d.productionOrders < min) {
					min = d.productionOrders;
				}
				if (d.purchaseRequisitions && d.purchaseRequisitions < min) {
					min = d.purchaseRequisitions;
				}
				if (d.plannedProductionOrders && d.plannedProductionOrders < min) {
					min = d.plannedProductionOrders;
				}
				if (d.nonValueSupplys && d.nonValueSupplys < min) {
					min = d.nonValueSupplys;
				}
				if (d.targetQty && d.targetQty < min) {
					min = d.targetQty;
				}
				if (d.safetyStock && d.safetyStock < min) {
					min = d.safetyStock;
				}
				if (d.shortageQuantity && d.shortageQuantity < min) {
					min = d.shortageQuantity;
				}
				if (vm.historicalValue === vm.historicalMetrics) {
					_.forEach(vm.itemMetrics, function (itemMetric) {
						var val = d[itemMetric.key];
						if (itemMetric.selected && typeof val === 'number' && !isNaN(val) && val < min) {
							min = val;
						}
					});
				}
				return min;
			});
		}

		function findMaxOfData(data) {
			return d3.max(data, function (d) {
				var max = -Infinity;

				if (d.availableQuantity && d.availableQuantity > max) {
					max = d.availableQuantity;
				}
				if (d.purchaseOrders && d.purchaseOrders > max) {
					max = d.purchaseOrders;
				}
				if (d.purchaseRequisitions && d.purchaseRequisitions > max) {
					max = d.purchaseRequisitions;
				}
				if (d.productionOrders && d.productionOrders > max) {
					max = d.productionOrders;
				}
				if (d.plannedProductionOrders && d.plannedProductionOrders > max) {
					max = d.plannedProductionOrders;
				}
				if (d.nonValueSupplys && d.nonValueSupplys > max) {
					max = d.nonValueSupplys;
				}
				if (d.targetQty && d.targetQty > max) {
					max = d.targetQty;
				}
				if (d.safetyStock && d.safetyStock > max) {
					max = d.safetyStock;
				}
				if (d.shortageQuantity && d.shortageQuantity > max) {
					max = d.shortageQuantity;
				}
				if (vm.historicalValue === vm.historicalMetrics) {
					_.forEach(vm.itemMetrics, function (itemMetric) {
						var val = d[itemMetric.key];
						if (itemMetric.selected && typeof val === 'number' && !isNaN(val) && val > max) {
							max = val;
						}
					});
				}
				return max;
			});
		}

		function drawChartWhenVisible(config) {
			var chartEl = document.getElementById(vm.chartId);
			if (!chartEl) {
				return;
			}
			if (!chartEl.clientWidth) {
				if (chartVisibilityObserver) {
					return;
				}
				chartVisibilityObserver = new ResizeObserver(function () {
					if (!chartEl.clientWidth) {
						return;
					}
					chartVisibilityObserver.disconnect();
					chartVisibilityObserver = null;
					generateStockRequirementChart();
				});
				chartVisibilityObserver.observe(chartEl);
				return;
			}
			c3.generate(config);
		}

		function generateStockRequirementChart() {
			var useItemMetrics = vm.historicalValue === vm.historicalMetrics;
			var showLineForToday = (stockRequirementMinDate && stockRequirementMinDate.isBefore(getEndOfWeek(moment()))) || useItemMetrics;
			var leadTimeRegionMinDate = useItemMetrics ? moment() : stockRequirementMinDate;
			var valuesToShow = ['pastDuePurchaseOrders', 'totalSupplyCount', 'forecasts', 'requirements', 'inventoryExpiration', 'productionOrdersDemands',
				'plannedProductionOrderDemands', 'transferOrders', 'plannedTransferOrders', 'customerOrders', 'purchaseOrders', 'purchaseRequisitions',
				'productionOrders', 'plannedProductionOrders', 'nonValueSupplys', 'shortageQuantity', 'targetQty', 'availableQuantity', 'safetyStock'];
				
			var chartData;
			if (useItemMetrics) {
				valuesToShow = valuesToShow.slice(0, -1);
				chartData = combineItemMetricsWithMrpData(itemMetricData, mrpListData);
				for (var i = 0; i < vm.itemMetrics.length; i++) {
					// erpOrderPolicy is string-valued; show in the metric list/tooltip only (not as a y-series)
					if (vm.itemMetrics[i].selected && vm.itemMetrics[i].key !== 'erpOrderPolicy') {
						valuesToShow.push(vm.itemMetrics[i].key);
					}
				}
			} else {
				chartData = [].concat(mrpListData); 
			}
			chartData = applyDateFiltersToMrpData(chartData);
			if (chartData.length === 0) {
				return;
			}
			var config = {};
			config.bindto = '#' + vm.chartId;
			config.data = {
				json: chartData,
				keys: {
					x: 'endDate',
					value: valuesToShow
				},
				types: {
					forecasts: 'point',
					requirements: 'point',
					inventoryExpiration: 'point',
					productionOrdersDemands: 'point',
					plannedProductionOrderDemands: 'point',
					transferOrders: 'point', 
					plannedTransferOrders: 'point', 
					customerOrders: 'point', 
					purchaseOrders: 'point',
					purchaseRequisitions: 'point', 
					productionOrders: 'point',
					plannedProductionOrders: 'point',
					nonValueSupplys: 'point',
					pastDuePurchaseOrders: 'point',
					totalSupplyCount: 'bar',
					targetQty: 'line',
					minimumOrderQuantity: 'line',
					safetyStock: 'line',
					safetyTime: 'line',
					safetyStockComputed: 'line',
					availableQuantity: 'area',
					shortageQuantity: 'area',
					requirementsInsideLeadTime: 'line',
					blockedStock: 'line',
					onOrderInsideLeadTime: 'line',
					unrestrictedAndConsignmentStock: 'area',
					inventoryOnHand: 'line',
					daysCoverage: 'line',
					daysUntilShortage: 'line',
					pastDueRequirements: 'line',
					totalRequirements: 'line',
					averageHistoricalUsage: 'line',
					pastDuePOs: 'line',
					totalPOs: 'line',
					targetQuantity: 'line',
					itemCost: 'line',
					poToActionPotentialSavings: 'line',
					poToActionRemainingPOs: 'line',
					poToActionRemainingRequirements: 'line',
					aggregateRiskScore: 'line',
					minLevel: 'line',
					maxLevel: 'line',
					orderInterval: 'line',
					leadTime: 'line',
					reorderPoint: 'line',
					reorderQuantity: 'line',
					erpExceptionMsgPoCt: 'line',
					apexPoActionPoCt: 'line'
				},
				colors: {
					forecasts: '#FFFFFF',
					requirements: '#FFFFFF',
					inventoryExpiration: '#FFFFFF',
					productionOrdersDemands: '#FFFFFF',
					plannedProductionOrderDemands: '#FFFFFF',
					transferOrders: '#FFFFFF', 
					plannedTransferOrders: '#FFFFFF', 
					customerOrders: '#FFFFFF', 
					purchaseOrders: '#8B36B4',
					totalSupplyCount: '#8B36B4',
					purchaseRequisitions: '#8B36B4', 
					productionOrders: '#8B36B4',
					plannedProductionOrders: '#8B36B4',
					nonValueSupplys: '#8B36B4',
					pastDuePurchaseOrders: '#8B36B4',
					shortageQuantity: '#FA1647',
					targetQuantity: '#5C9F07',
					targetQty: '#5C9F07',
					minimumOrderQuantity: '#00838F',
					safetyStock: '#5C9F07',
					availableQuantity: '#FF6700',
					requirementsInsideLeadTime: '#8B36B4',
					blockedStock: '#FF9800',
					onOrderInsideLeadTime: '#296E00',
					unrestrictedAndConsignmentStock: '#FF6700',
					inventoryOnHand: '#AA0056',
					daysCoverage: '#4F00AF',
					daysUntilShortage: '#C43500',
					pastDueRequirements: '#FF58B1',
					totalRequirements: '#52B3FB',
					pastDuePOs: '#67676A',
					totalPOs: '#8B36B4',
					aggregateRiskScore: '#000000',
					minLevel: '#00796B',
					maxLevel: '#C62828',
					erpOrderPolicy: '#5D4037',
					orderInterval: '#6A1B9A',
					leadTime: '#1565C0',
					reorderPoint: '#EF6C00',
					reorderQuantity: '#2E7D32',
					erpExceptionMsgPoCt: '#AD1457',
					apexPoActionPoCt: '#4527A0'
				}
			};

			var endDateForLeadTime = moment().tz('UTC').add(vm.itemMasterData.leadTimeInDaysFloat, 'days');
			config.regions = [{
				start: leadTimeRegionMinDate.toDate(),
				end: endDateForLeadTime.toDate(),
				class: 'insideLeadTime'
			}];
			// c3 draws lines/areas by connecting adjacent points, so a value whose
			// series neighbors are empty produces no visible segment and would only
			// be discoverable via the tooltip. Detect these isolated points per series
			// so we can render a marker just for them (keeping dense lines dot-free).
			var isolatedPoints = {};
			function hasNumericValue(row, key) {
				var v = row ? row[key] : undefined;
				return typeof v === 'number' && !isNaN(v);
			}
			valuesToShow.forEach(function (key) {
				var indices = {};
				for (var r = 0; r < chartData.length; r++) {
					if (hasNumericValue(chartData[r], key) &&
							!hasNumericValue(chartData[r - 1], key) &&
							!hasNumericValue(chartData[r + 1], key)) {
						indices[r] = true;
					}
				}
				isolatedPoints[key] = indices;
			});
			config.point = {
				show: function (d) {
					return !!(isolatedPoints[d.id] && isolatedPoints[d.id][d.index]);
				}
			};
			config.legend = {
				show: false
			};
			if (showLineForToday) {
				xGridLines.push({
					value: moment().startOf('day').toDate(),
					text: 'Today',
					class: 'todayClass'
				});
			}
			config.grid = {
				x: {
					show: false,
					lines: xGridLines
				},
				y: {
					show: true,
					lines: [{
						value: 0
					}]
				}
			};
			if (shortagesExist) {
				config.grid.y.lines = [{
					value: 0,
					class: 'zeroLine'
				}];
			}
			config.padding = {
				left: 40,
				right: 20
			};
			config.size = {
				height: 194
			};

			// find min/max y-axis values
			// XXX copied from metric-chart.directive.js. deduplicate?
			var minAxisValue = findMinOfData(config.data.json) || 0;
			var maxAxisValue = findMaxOfData(config.data.json) || 0;
			// pad up to 10% of the y-range, less if the padding would cross 0
			var yAxisPadding = (maxAxisValue - minAxisValue) * 0.1;
			// pad by 10% of the value if max and min are the same
			// if both are zero, chart will only show 0 on y-axis
			if (yAxisPadding === 0) {
				yAxisPadding = minAxisValue * 0.1;
			}
			// don't go below zero if there are no negative values
			if (minAxisValue >= 0) {
				minAxisValue -= Math.min(yAxisPadding, minAxisValue);
			} else {
				minAxisValue -= yAxisPadding;
			}
			// don't go above zero if there are no positive values
			// subtracting a negative so it won't concat strings
			if (maxAxisValue <= 0) {
				maxAxisValue -= -1 * Math.min(yAxisPadding, maxAxisValue * -1);
			} else {
				maxAxisValue -= -1 * yAxisPadding;
			}
			// round range endpoints
			var range = {
				'min': minAxisValue,
				'max': maxAxisValue
			};
			range = fullPageChart.roundRangeValues(range, 5, true);
			minAxisValue = range.min;
			maxAxisValue = range.max;

			var numberOfXAxisLabels = 7;
			// For a timeseries x-axis, axis.x.padding is measured in milliseconds (it is
			// added to the domain), not pixels. The previous {left:10, right:10} added
			// only 10ms, so points/bars on the first and last dates landed on the plot's
			// clip edge and were cut off. Pad by a few days so edge values render fully.
			var xAxisPaddingMs = 1 * 24 * 60 * 60 * 1000;
			config.axis = {
				x: {
					'type': 'timeseries',
					localtime: false,
					tick: {
						format: function (x) {
							return $filter('date')(x, 'shortDate', 'UTC');
						},
						outer: false,
						count: numberOfXAxisLabels
					},
					padding: {
						left: xAxisPaddingMs,
						right: xAxisPaddingMs
					}
				},
				y: {
					tick: {
						format: numberFormatService.get,
						count: 5
					},
					min: minAxisValue,
					max: maxAxisValue,
					padding: {
						bottom: 0,
						top: 0
					}
				}
			};
			var numberOfColumns = mrpListData.length;
			var computedRatio = 1 / (((numberOfColumns - numberOfXAxisLabels) / numberOfXAxisLabels) + 0.6) * 0.5;
			config.bar = {
				width: {
					// inspired by https://github.com/c3js/c3/issues/1368
					// using axis.x.tick.count messes up auto bar width
					ratio: Math.min(1, Math.abs(computedRatio))
				}
			};
			config.tooltip = {
				contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
					var tooltip = this.CLASS.tooltip;
					var tooltipName = this.CLASS.tooltipName;

					// convert list of data values to an object for convenience
					var data = {};
					for (var i = d.length - 1; i >= 0; i--) {
						data[d[i].id] = d[i].value;
					}

					var text = '<table class="' + tooltip + '">';

					var weekStart = moment(d[0].x).tz('UTC').startOf('isoWeek').subtract(1, 'day').toDate();
					var startDate = $filter('date')(weekStart, 'shortDate', 'UTC');
					var endDate = $filter('date')(getEndOfWeek(d[0].x).toDate(), 'shortDate', 'UTC');
					var title = startDate + ' - ' + endDate;
					var hideMrpData = false;
					var hideItemMetricData = false;
					if (d[0].x.getTime() < (new Date()).getTime() && useItemMetrics) {
						hideMrpData = true;
						title = $filter('date')(d[0].x, 'shortDate', 'UTC');
					} else if (d[0].x.getTime() >= (new Date()).getTime() || !useItemMetrics) {
						hideItemMetricData = true;
					}
					text += '<tr><th colspan="2">' + title + '</th></tr>';

					function getHtmlRowForTooltip(metricId, metricDisplayName, showBorder) {
						var text = '';
						text += '<tr class="' + tooltipName + '-' + metricId + '">';
						text += '<td class="name"><span style="background-color:' + color(metricId) + (showBorder ? ';border:1px solid black' : '') +
							'"></span>' + metricDisplayName + '</td>';
						text += '<td class="value">' + formatterService.formatDecimal(data[metricId], null, null, true) + '</td>';
						text += '</tr>';
						return text;
					}

					// Target Quantity
					if (data.targetQty && !hideMrpData) {
						text += getHtmlRowForTooltip('targetQty', 'Target Qty');
					}

					// Aggregate Risk Score
					if (data.aggregateRiskScore && !hideMrpData) {
						text += getHtmlRowForTooltip('aggregateRiskScore', 'Aggregate Risk Score');
					}

					// Available Quantity
					if (data.shortageQuantity && !hideMrpData) {
						// shortage
						text += getHtmlRowForTooltip('shortageQuantity', 'Available Qty');
					} else if (!hideMrpData) {
						// no shortage
						if (!data.availableQuantity) {
							data.availableQuantity = 0;
						}
						text += getHtmlRowForTooltip('availableQuantity', 'Available Qty');
					}

					// Supply
					if (data.purchaseOrders > 0 && !hideMrpData) {
						text += getHtmlRowForTooltip('purchaseOrders', 'Purchase Order');
					}
					if (data.purchaseRequisitions > 0 && !hideMrpData) {
						text += getHtmlRowForTooltip('purchaseRequisitions', 'Purchase Requisition');
					}
					if (data.productionOrders > 0 && !hideMrpData) {
						text += getHtmlRowForTooltip('productionOrders', 'Production Order');
					}
					if (data.plannedProductionOrders > 0 && !hideMrpData) {
						text += getHtmlRowForTooltip('plannedProductionOrders', 'Planned Production Order');
					}
					if (data.nonValueSupplys > 0 && !hideMrpData) {
						text += getHtmlRowForTooltip('nonValueSupplys', 'Non Value Supply');
					}

					// Demands
					if (data.forecasts > 0 && !hideMrpData) {
						text += getHtmlRowForTooltip('forecasts', 'Forecast', true);
					}
					if (data.requirements > 0 && !hideMrpData) {
						text += getHtmlRowForTooltip('requirements', 'Requirement', true);
					}
					if (data.inventoryExpiration > 0 && !hideMrpData) {
						text += getHtmlRowForTooltip('inventoryExpiration', 'Inventory Expiration', true);
					}
					if (data.productionOrdersDemands > 0 && !hideMrpData) {
						text += getHtmlRowForTooltip('productionOrdersDemands', 'Production Orders', true);
					}
					if (data.plannedProductionOrderDemands > 0 && !hideMrpData) {
						text += getHtmlRowForTooltip('plannedProductionOrderDemands', 'Planned Production Order', true);
					}
					if (data.transferOrders > 0 && !hideMrpData) {
						text += getHtmlRowForTooltip('transferOrders', 'Transfer Order', true);
					}
					if (data.plannedTransferOrders > 0 && !hideMrpData) {
						text += getHtmlRowForTooltip('plannedTransferOrders', 'Planned Transfer Order', true);
					}
					if (data.customerOrders > 0 && !hideMrpData) {
						text += getHtmlRowForTooltip('customerOrders', 'Customer Order', true);
					}

					// Past Due Purchase Orders
					if (data.pastDuePurchaseOrders > 0 && !hideMrpData) {
						text += getHtmlRowForTooltip('pastDuePurchaseOrders', 'Past Due POs');
					}

					if (data.safetyStock && !hideMrpData) {
						text += getHtmlRowForTooltip('safetyStock', 'Safety Stock');
					}

					if (!hideItemMetricData) {
						_.forEach(vm.itemMetrics, function (itemMetric) {
							if (!itemMetric.selected) {
								return;
							}
							if (itemMetric.key === 'erpOrderPolicy') {
								var polLabel = data[itemMetric.key + 'Label'];
								if (polLabel !== null && polLabel !== undefined && polLabel !== '') {
									text += '<tr class="' + tooltipName + '-' + itemMetric.key + '">';
									text += '<td class="name"><span style="background-color:' + color(itemMetric.key) +
										'"></span>' + itemMetric.display + '</td>';
									text += '<td class="value">' + _.escape(String(polLabel)) + '</td></tr>';
								}
								return;
							}
							var metricVal = data[itemMetric.key];
							if (metricVal !== null && metricVal !== undefined && metricVal !== '--' &&
								(typeof metricVal === 'number' ? !isNaN(metricVal) : false)) {
								text += getHtmlRowForTooltip(itemMetric.key, itemMetric.display);
							}
						});
					}
					return text + '</table>';
				}
			};

			// the timeout is necessary for the chart to be positioned and sized correctly
			$timeout(function () {
				drawChartWhenVisible(config);
			}, 0);
		}

		var restoreFilterListener;

		function init(param) {
			if (vm.chartId === 'stockRequirementChart') {
				vm.historicalValue = vm.openSupplyAndDemand;
			} else {
				vm.historicalValue = vm.historicalMetrics;
			}
			vm.viewMode = vm.historicalValue;
			vm.filterValues = stockRequirementFiltersService.getDateFilter(vm.viewMode);
			vm.supplyFilters = stockRequirementFiltersService.getSupplyFilters();
			if (!stockRequirementFiltersService.getOpened(vm.viewMode)) {
				stockRequirementFiltersService.setOpened(vm.viewMode, true);
			}
			if (param && param.useRootCauseDate) {
				// We want to use the root cause date in our filter, so don't load the
				// chart until the root cause date has been loaded
				doUpdateConfig = false;
				getRootCauseDate(true).then(function(response) {
					getItemMetrics(true);
					getMrpList();
				});
				restoreFilterListener = $scope.$on('itemDrilldownClosed', function(event, param) {
					vm.filterValues.filterBeginDate = oldFilterBeginDate;
					vm.filterValues.filterEndDate = oldFilterEndDate;
					vm.itemMetrics.forEach(function(metric) {
						if (oldItemMetrics && oldItemMetrics.length) {
							if (oldItemMetrics.indexOf(metric.key) > -1) {
								metric.selected = true;
							} else {
								metric.selected = false;
							}
						}
					});
				});
			} else {
				getItemMetrics();
				getMrpList();
			}
			if (vm.chartId === 'stockRequirementChart') {
				vm.filtersChanged = isConfigDifferentFromSite();
			}
		}
		var listener;
		this.$onInit = function () {
			if (vm.mrpTabReady){
				vm.mrpTabReady = false;
				init();
			} else {
				listener = $scope.$on('mrpChartReadyToLoad', function (event, param) {
					init(param);
				});
			}
		};

		$scope.$on('$destroy', function () {
			if (chartVisibilityObserver) {
				chartVisibilityObserver.disconnect();
			}
			storeService.dispatch(storeService.actionCreators.itemDrilldown.resetChartTimeRange(vm.viewMode));
			stockRequirementFiltersService.resetDateFilterData();
			restoreFilterListener && restoreFilterListener();
			unsubscribe && unsubscribe();
			listener && listener();
		});
	}
})();
